import firebase from 'firebase';
import Airtable from 'airtable';
import readAndCompressImage from 'browser-image-resizer';
const imagesConfig = {
    quality: 0.7,
    maxWidth: 200,
    maxHeight: 200,
    autoRotate: true,
};

const base = new Airtable({apiKey: 'keyFbTzvaieWIQW7N'}).base('appOJJaqwNqmBXHqH');
const polyline = require("google-polyline");
const greatCircle = require("great-circle");


const googleMapsClient = require('@google/maps').createClient({
    key: 'AIzaSyCnc2p1yCo0mBH8xzQGgHWnudlW3Ej4zyA',
    Promise: Promise // 'Promise' is the native constructor.
});

const force = true;


// Get a reference to the storage service, which is used to create references in your storage bucket
let storage = null;
// Create a storage reference from our storage service
let storageRef = null;

export function reloadLeg(id) {
    return new Promise((resolve, reject) => {
        base('Legs').select({
            maxRecords: 1000,
            view: "Grid view",
            filterByFormula: "{ID} = '" + id + "'"
        }).eachPage(async function page(records) {

            for (let record of records) {
                await parseRecord(record);
                resolve(record);
            }

        }, function done(err) {
            if (err) {
                console.error(err);
                reject(err);
            }
        });
    })
}


export function reloadLegs(update) {
    return new Promise((resolve, reject) => {
        base('Legs').select({
            maxRecords: 1000,
            view: "Grid view",
        }).eachPage(async function page(records, fetchNextPage) {

            for (let record of records) {
                let result = await parseRecord(record);
                update(result);
            }
            fetchNextPage();

        }, function done(err) {
            resolve();
            if (err) {
                console.error(err);
                reject(err);
            }
        });
    })
}

function getLegs() {
    base('Legs').select({
        maxRecords: 1000,
        view: "Grid view",
        // filterByFormula: "{ID} = 'ThalysAmsterdamParis'"
    }).eachPage(async function page(records, fetchNextPage) {

        for (let record of records) {
            await parseRecord(record);
        }
        fetchNextPage();

    }, function done(err) {
        if (err) {
            console.error(err);
        }
    });
}

export function reloadShips(update) {


// Get a reference to the storage service, which is used to create references in your storage bucket
    storage = firebase.storage();

// Create a storage reference from our storage service
    storageRef = storage.ref();

    return new Promise((resolve, reject) => {
        base('Ships').select({
            maxRecords: 100,
            view: "Grid view",
        }).eachPage(async function page(records, fetchNextPage) {

            for (let record of records) {
                let result = await parseShipRecord(record);
                update(result);
            }
            fetchNextPage();

        }, function done(err) {
            resolve();
            if (err) {
                console.error(err);
                reject(err);
            }
        });
    });
}

async function parseShipRecord(record) {
    let id = record.id;
    if (!id) return;

    console.log(id);

    // console.log(info);
    let docRef = firebase.firestore().collection('ships').doc(id);


    //Photos
    let photos = [];
    if(record.get("Photo")) {
        let i = 1;
        for (let photo of record.get("Photo")) {
            let extension = ".png";
            if (photo.type === "image/jpeg") extension = ".jpg";
            let spaceRef = storageRef.child('images/' + id + '-' + i + extension);
            await fetch(photo.url)
                .then(async res => {
                    let resizedImage = await readAndCompressImage(await res.blob(), imagesConfig);
                    return spaceRef.put(resizedImage)
                    // const dest = fs.createWriteStream("photos/" + filename);
                    // res.body.pipe(dest);
                }).then(async () => {
                    photos.push(await spaceRef.getDownloadURL());
                }).catch(e => {
                    console.error(e);
                });
            i++;
        }
    }

    let info = {
        name: record.get("Name"),
        type: record.get("Type of ship") || "",
        passengers: record.get("Passengers") || "",
        crew: record.get("Crew") || "",
        cargo: record.get("Cargo") || "",
        homepageUrl: record.get("Homepage") || "",
        itineraryUrl: record.get("Itinerary") || "",
        company: record.get("Company") || "",
        introduction: record.get("Introduction Story") || "",
        photoSourceUrl: record.get("Photo source site") || "",
        photos,
    };

    console.log(info);

    await docRef.set(info);
    return "Ship " + id + " imported";

}

async function parseRecord(record) {
    let id = record.get('ID');
    if (!id) return;

    console.log(id);

    // console.log(info);
    let docRef = firebase.firestore().collection('legs').doc(id);
    //
    // return await docRef.get()
    //     .then(async doc => {
    //         if (!doc.exists || force) {

    console.log("fetching details...");

    let origin, destination;

    let geocode = await getLocation(record.get("Departure City") + ", " + record.get("Departure Country"));
    origin = geocode.location;
    let geocode2 = await getLocation(record.get("Arrival City") + ", " + record.get("Arrival Country"));
    destination = geocode2.location;

    // let originParts = record.get("Departure Location").replace("\ \g", "").split(",").map(parseFloat);
    // let origin = new firebase.firestore.GeoPoint(originParts[0], originParts[1]);
    // let destinationParts = record.get("Arrival Location").replace("\ \g", "").split(",").map(parseFloat);
    // let destination = new firebase.firestore.GeoPoint(destinationParts[0], destinationParts[1]);

    let path = polyline.encode([
        [origin.latitude, origin.longitude],
        [destination.latitude, destination.longitude],
    ]);

    let shipLink = null;
    let ship = record.get("Ship");
    if (ship && ship.length === 1) {
        shipLink = ship[0];
    }

    let duration = record.get("Duration") || null;
    let speed = null;
    let distance = greatCircle.distance(origin.latitude, origin.longitude, destination.latitude, destination.longitude, "NM");
    if (duration) {
        speed = distance / (duration * 24);
    }

    let info = {
        departure: {
            date: record.get("Departure Date"),
            city: record.get("Departure City"),
            country: record.get("Departure Country"),
            location: origin,
        },
        arrival: {
            date: record.get("Arrival Date"),
            city: record.get("Arrival City"),
            country: record.get("Arrival Country"),
            location: destination,
        },
        company: record.get("Company") || "",
        ship: shipLink,
        cost: record.get("Cost") || null,
        reference: record.get("Reference") || "",
        duration,
        distance,
        averageSpeed: speed,
        path,
    };

    console.log(info);

    // return;

    await docRef.set(info);
    return "Leg " + id + " imported";

    //     } else {
    //         console.log('Skipping...');
    //
    //     }
    //
    //
    // })
    // .catch(err => {
    //     console.log('Error getting document', err);
    // });

}


async function getLocation(place) {
    console.log("Place lookup: " + place);

    let matches = place.match(/\[([\d.]+), ?(-?[\d.]+)]/);
    if (matches && matches.length > 1) {
        let lat = parseFloat(matches[1]);
        let lng = parseFloat(matches[2]);
        // console.log("Coordinates found: ", lat, lng);

        return {
            location: new firebase.firestore.GeoPoint(lat, lng),
            address: "coords",
        };
    }

    return googleMapsClient.geocode({
        address: place,
        // bounds: {
        //     north: 71.53956,
        //     east: 38.24399,
        //     south: 35.64133,
        //     west: -13.084135,
        // }
    })
        .asPromise()
        .then((response) => {
            if (response.json.results && response.json.results.length > 0) {

                let i = 0;
                // for (let result of response.json.results){
                //     console.log(i, result);
                //     i++;
                // }

                let firstResult = response.json.results[0];
                return {
                    location: new firebase.firestore.GeoPoint(firstResult.geometry.location.lat, firstResult.geometry.location.lng),
                    address: firstResult.formatted_address,
                };
            }
            console.error("No location found for '" + place + "'");
            return null;
        })
        .catch((err) => {
            console.log(err);
            return null;
        });
}


// WEBPACK FOOTER //
// ./src/functions/airtable.js